var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenLeaf2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 157.917,
    height: 129.626,
    viewBox: "0 0 157.917 129.626",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    transform: "matrix(-0.999, 0.052, -0.052, -0.999, 367.583, 3500.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M99.891,0A103.267,103.267,0,0,0,57.908,8.488,115.634,115.634,0,0,0,22.384,33.149c-3.448,3.492-6.571,6.9-9.355,10.259A61.358,61.358,0,0,0,5.94,53.917,50.1,50.1,0,0,0,1.522,65.663,59.525,59.525,0,0,0,0,79.748,41.914,41.914,0,0,0,3.221,96.138a43.183,43.183,0,0,0,8.788,13.383,41.7,41.7,0,0,0,12.964,9.073,38.43,38.43,0,0,0,15.877,3.325,38.822,38.822,0,0,0,15.926-3.325A41.617,41.617,0,0,0,69.8,109.522a43.173,43.173,0,0,0,8.788-13.383,41.914,41.914,0,0,0,3.221-16.391,151.016,151.016,0,0,1,7.072-45.814Z",
    transform: "translate(188.888 3419.332) rotate(109)",
    fill: "#308e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M0,.045S30.95,6.833,49.421,7.707,89.354,4.074,89.354,4.074L89.158,0S60.816,4.564,49.421,4.074,0,.045,0,.045Z",
    transform: "translate(132.257 3467.261) rotate(-139)",
    fill: "#57ce57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M0,11.661S12.4,9.693,19.061,6.49A65.511,65.511,0,0,0,29.933,0l3.708,6.49s-6.879,3.087-12.948,5.171S.225,15.785.225,15.785Z",
    transform: "translate(57.389 3417.632) rotate(-139)",
    fill: "#308e30"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenLeaf2);
export default __webpack_public_path__ + "static/media/green-leaf-2.26c5e01087d5341cdcb0c4285c6f719f.svg";
export { ForwardRef as ReactComponent };